module.exports = __webpack_public_path__ + "img/tannenbaum.dfc208f6.svg";